import React from 'react';
import Login from '../../components/login';

const LoginContainer = () => <Login />;

export default LoginContainer;
